// extracted by mini-css-extract-plugin
export default {"highZIndexPopup":"ChangePriceCategoryDialog_highZIndexPopup__sFmOM"};